import { FC } from "react";
import "video.js/dist/video-js.css";
import Like from "../../../assets/icon/Like";
import { useAppDispatch, useAppSelector } from "../../../hooks/redux-hooks";
import {
  selectMainState,
  setButtonState,
  setIdTrack,
  setAudioOverTop,
  setPlayRadio,
  setPlayTrack,
  setTrackLink,
} from "../../../store/slices/main";
import ButtonPlayer from "../../common/button/ButtonPlayer";
import LikePlayer from "../../../assets/icon/LikePlayer";
import { addRemoveContestsLike } from "../../../api/asyncThuncks/contestsCards";
import { addRemoveLike } from "../../../api/asyncThuncks/audioTracks";
import PlayCounter from "../../../assets/icon/PlayCounter";
import Cover from "../../../assets/icon/Cover";
import { getHomePageSetting } from "../../../api/asyncThuncks/settings";
import {
  setSettingPlayingPlaylistId,
  setSettingPlaylistPlaying,
  setSettingPlaylistTrackNumber,
  setSettingStopPlayingPlaylist,
} from "../../../store/slices/playlists";
import VoteButton from "../../../assets/icon/VoteButton";

type IProps = {
  index: number;
  id: string;
  icon?: string;
  trackName: string;
  artist: string;
  like?: number;
  isLiked?: boolean;
  length?: string;
  arrayLength: number;
  trackLink: string;
  buttonStates: string;
  idRow?: string;
  keyRow?: number;
  isHovered: boolean;
  contestId?: string;
  playCounter?: number;
  onToggleLike: (id: string) => void;
};

const Playlist: FC<IProps> = ({
  index,
  id,
  icon,
  trackName,
  artist,
  like,
  isLiked,
  length,
  arrayLength,
  trackLink,
  buttonStates,
  idRow,
  keyRow,
  isHovered,
  contestId,
  playCounter,
  onToggleLike,
}) => {
  const dispatch = useAppDispatch();

  const {
    radioPlayer: { player, radio },
    idPlayingTrack,
  } = useAppSelector(selectMainState);

  const likeHandleClick = async () => {
    onToggleLike(id);

    if (contestId) {
      await dispatch(addRemoveContestsLike({ contestId, audioTrackId: id }));
    } else {
      await dispatch(addRemoveLike({ id }));
    }
  };

  const handleClick = () => {
    dispatch(setPlayTrack(true));
    dispatch(setPlayRadio(false));
    dispatch(setTrackLink(trackLink));

    if (player && radio) {
      player.stop();
      dispatch(setButtonState("play"));
    }
    dispatch(
      setIdTrack({
        idTrack: id,
        cover: { icon },
        name: trackName,
        artist,
        isLiked,
        trackLink,
      })
    );

    dispatch(setAudioOverTop(true));
    stopNextPlaying();
  };

  const stopNextPlaying = () => {
    dispatch(setSettingPlaylistTrackNumber(0));
    dispatch(setSettingStopPlayingPlaylist(true));
  };

  return (
    <div
      className={`flex justify-between items-center max-h-16 md:max-h-10 w-full cursor-pointer transition-all duration-80 px-3 py-6 ${
        isHovered &&
        keyRow === index &&
        "md:hover:bg-black hover:bg-opacity-[4%] md:hover:bg-opacity-20 rounded-sm"
      }`}
    >
      <div onClick={handleClick} className="flex items-center w-full">
        <div className="flex items-center justify-center w-[3.75rem] h-[3.75rem] md:w-[2.5rem] md:h-[2.5rem] rounded-md overflow-hidden relative">
          {icon ? (
            <img className="object-cover w-full h-full" src={icon} alt="icon" />
          ) : (
            <Cover />
          )}
          {isHovered && keyRow === index && (
            <div className="hidden w-5 h-5 md:block absolute top-1 left-1">
              <ButtonPlayer
                width="30"
                height="30"
                type={idPlayingTrack.idTrack === id ? "" : "play"}
                radio={false}
                playForTrack={true}
                onClick={handleClick}
              />
            </div>
          )}
        </div>
        <div className="pl-4 md:w-full md:flex md:items-center md:justify-between">
          <h4
            className={`min-w-[15rem] max-w-[15rem] text-base font-semibold text-ellipsis overflow-hidden whitespace-nowrap md:min-w-[25rem] md:max-w-[25rem] ${
              idPlayingTrack.idTrack === id ? "text-orange" : "text-black"
            }`}
          >
            {trackName}
          </h4>
          <p className="min-w-[15rem] max-w-[15rem] text-[13px] text-ellipsis overflow-hidden whitespace-nowrap md:min-w-[25rem] md:max-w-[25rem] md:text-center">
            {artist}
          </p>
          <div className="flex items-center text-[13px]">
            <Like isLikes={isLiked} />
            <div className="pl-1 ">
              <span>{like}</span>
              <span>・</span>
            </div>
            {/* {!contestId && (
              <>
                <PlayCounter />
                <div>
                  <span>{playCounter}</span>
                  <span>・</span>
                </div>
              </>
            )} */}
            <span>{length}</span>
          </div>
        </div>
      </div>
      <button onClick={likeHandleClick} className="md:pl-5">
        <LikePlayer isLiked={isLiked} />
      </button>
    </div>
  );
};

export default Playlist;
